mutation AddUserToWorkspace($workspaceId: ID!) {
  addCurrentUserToWorkspace(workspaceId: $workspaceId) {
    id
    name
  }
}
